// @flow

import { registerMetricEventListeners } from './metricEvents'
import { registerWebAnalyticsListeners } from './webAnalytics'
import { registerChatchampPixelListeners } from './chatchampPixel'

export function registerWizardEventListeners (): void {
  registerMetricEventListeners()
  registerWebAnalyticsListeners()
  registerChatchampPixelListeners()
}
